import { render } from "./NewStudentRow.vue?vue&type=template&id=b3c2ae18&scoped=true"
import script from "./NewStudentRow.vue?vue&type=script&lang=js"
export * from "./NewStudentRow.vue?vue&type=script&lang=js"

import "./NewStudentRow.vue?vue&type=style&index=0&id=b3c2ae18&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c2ae18"]])

export default __exports__